import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.828",
  height: "5.828",
  viewBox: "0 0 5.828 5.828"
}
const _hoisted_2 = {
  id: "bg_land_zhanglang_p",
  transform: "translate(1.414 1.414)"
}
const _hoisted_3 = ["stroke"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("line", {
        id: "Line_7",
        "data-name": "Line 7",
        y1: "3",
        x2: "3",
        fill: "none",
        stroke: _ctx.color === 0 ? 'red' : 'blue',
        "stroke-linecap": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_3)
    ])
  ]))
}